<template>
    <div
        v-if="coverage.length"
        class="requested-verification-documents d-flex flex-wrap align-items-center"
    >
        <span class="requested-verification-documents__label text-less-muted mr-50 mb-50">
            {{ translate(
                'Page(ReceivedRequest):Component(DocumentsAndWebpages):requested-documents',
                'Requested documents',
            ) }}:
        </span>

        <BBadge
            v-for="item in coverage"
            :key="item.type"
            :variant="item.isProvided ? 'light-success' : 'light-warning'"
            class="requested-verification-documents__badge mr-50 mb-50"
            :title="evidenceTypesTitle(item)"
        >
            <FeatherIcon
                v-if="item.isProvided"
                icon="CheckIcon"
                size="14"
                class="mr-25"
                aria-hidden="true"
            />
            <span>{{ verificationTypeLabel(item.type) }}</span>
            <span v-if="evidenceProgress(item)" class="ml-25">
                ({{ evidenceProgress(item) }})
            </span>
        </BBadge>
    </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import {
    buildRequestedVerificationDocumentCoverage,
    EVIDENCE_VERIFICATION_TYPE,
} from './requested-verification-document-coverage'

const TYPE_FALLBACKS = Object.freeze({
    doc: 'Declaration of conformity',
    compliant_statement: 'Compliance statement',
    evidence: 'Evidence report',
    safe_use: 'Safe-use instructions',
    dissembling: 'Disassembly instructions',
    other: 'Other verification document',
    cbam_communication_template: 'CBAM communication template',
    eudr_dd_statement: 'EUDR due-diligence statement',
})

export default {
    name: 'RequestedVerificationDocuments',
    components: { BBadge },
    props: {
        requestedDocuments: {
            type: Array,
            default: () => [],
        },
        requestedEvidenceReportTypes: {
            type: Array,
            default: () => [],
        },
        providedDocuments: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        coverage() {
            return buildRequestedVerificationDocumentCoverage({
                requestedDocuments: this.requestedDocuments,
                requestedEvidenceReportTypes: this.requestedEvidenceReportTypes,
                providedDocuments: this.providedDocuments,
            })
        },
    },
    methods: {
        translate(key, fallback, params = {}) {
            const translation = this.$t(key, params)

            return translation && translation !== key ? translation : fallback
        },
        verificationTypeLabel(type) {
            return this.translate(
                `Component(VerificationDocumentTypeEnum):${type}`,
                TYPE_FALLBACKS[type] || type,
            )
        },
        evidenceTypeLabel(type) {
            if (type && typeof type === 'object') {
                return type.title || type.name || String(type.id)
            }

            return String(type)
        },
        evidenceTypesTitle(item) {
            if (item.type !== EVIDENCE_VERIFICATION_TYPE) {
                return ''
            }

            return item.requestedEvidenceReportTypes
                .map(this.evidenceTypeLabel)
                .join(', ')
        },
        evidenceProgress(item) {
            if (
                item.type !== EVIDENCE_VERIFICATION_TYPE
                || item.requestedEvidenceReportTypes.length === 0
            ) {
                return ''
            }

            return `${item.providedEvidenceReportTypeCount}/${item.requestedEvidenceReportTypes.length}`
        },
    },
}
</script>

<style lang="scss" scoped>
.requested-verification-documents__badge {
    display: inline-flex;
    align-items: center;
    font-size: 0.9rem;
}

.requested-verification-documents__label {
    font-size: 0.9rem;
}
</style>
